import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import Button from 'components/common/Button/Button'
import Input from 'components/common/Input/Input'
import ResponseMessage from 'components/common/ResponseMessage/ResponseMessage'
import api from 'helpers/api'
import InfoMessage from 'components/common/InfoMessage/InfoMessage'
import style from 'styles/auth.module.scss'

const ResetPassword = () => {
  const { t } = useTranslation()
  const [errorMessage, setErrorMessage] = useState(false)
  const [isSuccessMessageDisplayed, setIsSuccessMessageDisplayed] = useState(false)

  const {
    register,
    handleSubmit,
    formState: { isValid },
  } = useForm({
    criteriaMode: 'all',
    delayError: 500,
    defaultValues: {
      email: '',
    },
    mode: 'onTouched',
  })

  const onSubmit = handleSubmit(async data => {
    setErrorMessage(false)
    try {
      const lang = (navigator.language || navigator.userLanguage).split('-').shift();
      const res = await api.post({
        url: '/auth/clients/forgot_password',
        data: { email: data.email, lang },
      })

      if (res.success) {
        setIsSuccessMessageDisplayed(true)
        setErrorMessage(false)
      } else {
        setErrorMessage(true)
        setIsSuccessMessageDisplayed(false)
      }
    } catch (error) {
      setErrorMessage(true)
    }
  })

  return (
    <>
      <h2 className={style.title}>{t('main:auth.resetPassword.reset')}</h2>

      <p className={classNames(style.description, style['reset-password'])}>
        {t('main:auth.resetPassword.resetDescription')}
      </p>
      {errorMessage && <ResponseMessage className={style['error-message']} label={t('main:errorMessages.general')} />}
      {isSuccessMessageDisplayed > 0 && (
        <InfoMessage
          className={style['success-message']}
          label={t('main:auth.resetPassword.emailSent')}
          type="success"
        />
      )}

      <form onSubmit={onSubmit} className={style.form}>
        <div className={style.inputs}>
          <div className={style.input}>
            <Input
              register={register('email', { required: true })}
              darkBg
              label="Email"
              placeholder={`${t('common:your')} ${t('common:form.email.placeholder')}`}
              type="email"
            />
          </div>
        </div>

        <Button
          label={t('main:auth.resetPassword.send')}
          className={style.button}
          onClick={handleSubmit}
          type="primary"
          disabled={!isValid}
        />
      </form>
    </>
  )
}

export default ResetPassword
